import { EditorState } from '../Editor.types';
import { AulaEntity } from '../Entities';
import { getActiveEntities } from '../utils/entities';

export const isInSelectionMode = (aulaEntity: AulaEntity) =>
  aulaEntity.type === 'lti' &&
  aulaEntity.params?.launchType === 'content-selection';

/**
 * Computes whether an EditorState has lti blocks that are in selection mode
 * thus cannot be persisted( i.e. content to share has not been selected yet)
 */
export const hasUnselectedLtiContent = (editorState: EditorState): boolean =>
  Object.values(getActiveEntities(editorState)).some(
    (aulaEntity: AulaEntity) => aulaEntity && isInSelectionMode(aulaEntity),
  );
